module.exports = __webpack_public_path__ + "img/info_btn.a00bc556.png";